import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';

import processSvg from '@assets/image/operations/process-get-01.svg';

const Introduction = () => {
  return (
    <Container className='padding2em1em'>
      <Row>
        <Col sm={6} className='padding1em'>
          <img src={processSvg} className='img-fluid' alt='ship package' />
        </Col>
        <Col sm={6}>
          <h1>松果极省</h1>
          <p>
            松果极省线是松果针对非急用用户设计的适合中大型包裹运输的定制线路。
            每周发货，货物发出后一般4-6周到达取货点，价格是松果极速的一半不到，是一条性价比极高的线路。
          </p>
          <ul className='h5 intro-list'>
            <li>4-6星期到达</li>
            <li>
              九种开放品名拼箱：
              <span className='text-muted'>
                书本，寝具，布艺，铁质用具，衣服，鞋子，塑料制品，纸艺包装，文教用品
              </span>
            </li>
            <li>
              价格便宜：书线$5/kg，其他线路如重量小于5kg,$7/kg；如重量在5kg-100kg之间，$5/kg；如重量超过100kg，$4/kg。
            </li>
            <li>所有包裹都不合并</li>
            <li>为20公斤以上大包裹用户提供免费送货上门服务</li>
            <li>
              凡是20公斤以下包裹请前往
              <Link to={'/station'}>
                <i className='fas fa-store'></i> 松果取货小站
              </Link>
            </li>
            <li>微信客服方便联系</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
};

export default Introduction;
